import React, { forwardRef, useImperativeHandle, useRef } from "react";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import { buildName } from "helper/tools";

const RevisarResetPasswordModal = forwardRef(({ item, reload }, ref) => {
  const modalButtonRef = useRef();

  useImperativeHandle(ref, () => ({
    toggleModal: () => {
      modalButtonRef.current.click();
    },
  }));

  let title = ` ¿Desea aprobar el reseteo de password de `;

  const nombre = buildName(item, true);

  const usernameNombre = `${nombre} (${item.username})`;

  const apply = async (aprobarRechazar) => {
    let response = await api
      .approveResetPassword(item.username, aprobarRechazar)
      .catch((e) => {
        if (e.esError && e.codigoError && e.mensaje) {
          toast.error(`Error al aprobar reset password. ${e.mensaje}`);
          return;
        }
        toast.error("Error al aprobar reset password.");
      });
    if (!response) {
      return;
    }

    toast.success("Reseteo exitoso!");

    if (reload != null) reload();
    modalButtonRef.current.click();
  };

  return (
    <>
      <button
        ref={modalButtonRef}
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target="#staticBackdropRevisarResetPassword"
        hidden
      >
        Launch static backdrop modal
      </button>

      <div
        className="modal fade"
        id="staticBackdropRevisarResetPassword"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropRevisarResetPasswordLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Resetear password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <form>
                <div className="mb-3">
                  <label htmlFor="recipient-name" className="col-form-label">
                    {title} <b>{usernameNombre}</b> ?
                  </label>
                  {/*<input type="text" className="form-control" id="recipient-name" />*/}
                </div>
                {/*  <div className="mb-3">
                  <label htmlFor="message-text" className="col-form-label">
                    Nota:
                  </label>
                  <textarea
                    className="form-control"
                    id="message-text"
                  ></textarea>
                </div>*/}
              </form>
            </div>

            <div className="modal-footer">
              <div className="">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={(e) => {
                    apply(true);
                  }}
                >
                  Aprobar
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ marginLeft: "10px" }}
                  onClick={(e) => {
                    apply(false);
                  }}
                >
                  Rechazar
                </button>
              </div>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default RevisarResetPasswordModal;
